(() => {
  const HANDLE = 'foldable-mini-laundry-machine-portable-compact-washer';
  const variants = [
    { name: 'Sage Green', price: 'Dhs. 129.00', image: null },
    { name: 'Lavender Purple', price: 'Dhs. 132.00', image: 'https://cdn.shopify.com/s/files/1/1015/5232/4889/files/foldable-mini-washer-lavender-purple.jpg?v=1786786515' },
    { name: 'Soft Pink', price: 'Dhs. 135.00', image: 'https://cdn.shopify.com/s/files/1/1015/5232/4889/files/foldable-mini-washer-soft-pink.jpg?v=1786786522' }
  ];

  const setupCard = (card) => {
    if (!card || card.dataset.laundryVariantReady === '1') return;
    const link = card.querySelector(`a[href*="/products/${HANDLE}"]`);
    if (!link) return;
    const mainImg = card.querySelector('.hdt-card-product__media--main');
    const priceWrap = card.querySelector('.hdt-price-wrapp');
    const colorItems = [...card.querySelectorAll('.hdt-color-list-item')].filter(el => !el.classList.contains('is--color-link'));
    if (!mainImg || !priceWrap || colorItems.length < 3) return;
    card.dataset.laundryVariantReady = '1';
    if (!variants[0].image) variants[0].image = mainImg.currentSrc || mainImg.src;

    colorItems.slice(0, 3).forEach((item, index) => {
      const data = variants[index];
      const input = item.querySelector('input[type="radio"]');
      const label = item.querySelector('label');
      const bg = item.querySelector('.hdt-color-bg') || label;
      if (!input || !label) return;
      input.disabled = false;
      input.dataset.laundryVariant = data.name;
      label.setAttribute('title', data.name);
      label.setAttribute('aria-label', data.name);
      if (bg) bg.style.backgroundColor = index === 0 ? '#C9D3C1' : index === 1 ? '#B8AFE8' : '#EBC6CF';

      const choose = (event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        colorItems.slice(0, 3).forEach(x => x.querySelector('input[type="radio"]')?.removeAttribute('checked'));
        input.checked = true;
        input.setAttribute('checked', 'checked');
        const price = priceWrap.querySelector('hdt-price');
        if (price) price.innerHTML = `<span class="sr-only sr-only--inline">Sale price</span><span class="hdt-money">${data.price}</span>`;
        const compare = priceWrap.querySelector('hdt-compare-at-price');
        if (compare) compare.hidden = true;
        if (data.image) {
          mainImg.src = data.image;
          mainImg.srcset = data.image;
          mainImg.removeAttribute('data-srcset');
        }
        card.querySelectorAll('a[data-pr-url]').forEach(a => {
          const base = a.getAttribute('href').split('?')[0];
          const vid = input.dataset.vid;
          a.setAttribute('href', vid ? `${base}?variant=${vid}` : base);
        });
      };
      label.addEventListener('click', choose, true);
      input.addEventListener('change', () => choose(null));
    });
  };

  const scanRoot = (root) => {
    if (!root || ![1, 9, 11].includes(root.nodeType)) return;
    if (root.matches?.('hdt-card-product')) setupCard(root);
    root.querySelectorAll?.('hdt-card-product').forEach(setupCard);
  };

  const initialScan = () => scanRoot(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialScan, { once: true });
  } else {
    initialScan();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) scanRoot(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
